import { HttpClient } from "../utils/HttpClient";

export const queueTask = async (code: string, data?: any) => {
    const requestId = new Date().getTime();
    await HttpClient.instance.post(requestId, "task/queue", { code, data });
};